// Trigger a PDF download of the user's transactions using the current auth token.
import api from "@/lib/api";
import { toast } from "sonner";

export async function downloadTransactionsPdf(filters = {}, tMsgSuccess, tMsgError, lang) {
  try {
    const params = new URLSearchParams();
    if (filters.start) params.set("start", filters.start);
    if (filters.end) params.set("end", filters.end);
    if (filters.type) params.set("type", filters.type);
    if (lang) params.set("lang", lang);
    const suffix = params.toString() ? `?${params}` : "";
    const res = await api.get(`/export/transactions.pdf${suffix}`, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
    const a = document.createElement("a");
    a.href = url; a.download = `malat_${new Date().toISOString().slice(0, 10)}.pdf`;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => window.URL.revokeObjectURL(url), 100);
    if (tMsgSuccess) toast.success(tMsgSuccess);
  } catch {
    if (tMsgError) toast.error(tMsgError);
  }
}
